import ApiService from '@/services/common/api.service';
import StorageService from '@/services/common/storage.service';
import { Constants } from "@/helpers/constants";

const CashService = {
    getCash,
    getCashDetail,
    getCashCurrency,
    getSummary,
    downloadExcel,
    exportExcel,
};

function extractCashIdAndBoxFolderId(response) {
    return {
        id: response.id,
        boxFolderId: response.boxFolderId,
    };
}

async function getCash (query = "") {
    let url = '/cash';
    if (query) {
        url += "?tourNumber=" + query;
    }
    try {
        let response = await ApiService.get(url);
        const cashIdAndBoxFolderId = extractCashIdAndBoxFolderId(response);
        StorageService.saveCashBoxFolderId(JSON.stringify(cashIdAndBoxFolderId));
        return response;
    } catch (error) {
        return error;
    }
}

async function getCashDetail (cashDmosId, tourNumber) {
    let url = '/cash/' + cashDmosId + "?tourNumber=" + tourNumber;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getCashCurrency (cashCurrencyId) {
    let url = '/cash/cash-currency/' + cashCurrencyId;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

async function getSummary (cashId) {
    try {
        let requestData = {
            method: 'get',
            url: `${process.env.API_URL}/cash/summary?cashId=` + cashId,
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    }catch (error) {
        return error;
    }
}

async function downloadExcel (cashId, tourInfo) {
    try {
        let requestData = {
            method: 'get',
            responseType: 'blob',
            url: `${process.env.API_URL}/cash/download-excel?cashId=` + cashId + `&tourInfo=` + encodeURIComponent(JSON.stringify(tourInfo)),
        };
        let response = await ApiService.customRequest(requestData);
        return response;
    }catch (error) {
        return error;
    }
}

async function exportExcel (cashId, tourInfo) {
    try {
        // let response = await ApiService.customRequest(requestData);

        // 本来は POST /cash/{id}/excel の呼びもとの画面から種別のようなデータを渡し、
        // ここの処理でハンドリングする実装とする方が統一的である。
        // しかし、この API を呼ぶユースケースは 携行現金収支明細 > 本登録 というもののみである想定であり
        // かつ、その際に用いるデータは一意に決まるため、ハンドリングの実装をなしとする。

        const cashIdAndBoxFolderId = JSON.parse(StorageService.getCashBoxFolderId());
        if (cashIdAndBoxFolderId.id != cashId) {
            console.log('CashService.exportExcel error', cashIdAndBoxFolderId, cashId);
        }
        tourInfo.boxFolderId = cashIdAndBoxFolderId.boxFolderId;

        let requestData = {
            method: 'post',
            data: tourInfo,
            url: `${process.env.API_URL}/cash/` + cashId + `/excel/`,
            isUpload: true,
        }
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}
export default CashService;



// WEBPACK FOOTER //
// ./src/services/module/cash.service.js